// Copyright 2023, Durable
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
/**
 * Component that displays when a fatal error occurs. This component should
 * contain no imported components or non-styling logic. This boundary may have
 * been hit outside of light or dark mode definition, so all styling must be
 * fully mode agnostic.
 */
function ErrorBoundaryDisplay() {
  const currentLocation = useLocation();
  const [initialErrorLocation, setInitialErrorLocation] =
    useState<string>(null);

  useEffect(() => {
    setInitialErrorLocation(currentLocation.pathname);
  }, [currentLocation.pathname]);

  // If the user has navigated away by any means, reload the page to clear
  // the error.
  useEffect(() => {
    if (
      initialErrorLocation != null &&
      initialErrorLocation != currentLocation.pathname
    ) {
      location.reload();
    }
  }, [currentLocation.pathname, initialErrorLocation]);

  return (
    <div className="w-full p-8 flex justify-center items-center flex-col">
      <div className="text-2xl font-sans my-5">
        We&apos;re sorry, something broke on our end.
      </div>
      <div className="text-base font-sans">
        You can help us fix this by contacting support to tell us what caused
        this error. To contact support, please&nbsp;
        <a href="mailto:hi@durable.ai">email us.</a>
      </div>
      <div className="flex">
        <button
          className={`text-lg my-5 font-sans text-coolGrey-1000 mx-3
          bg-durableTealDark-300 outline-0 border-0 hover:bg-durableTeal-200
          transition-colors rounded-full px-5 py-2 select-none cursor-pointer`}
          onClick={() => {
            window.location.assign("/");
          }}
        >
          Return Home
        </button>
        <button
          className={`text-lg my-5 font-sans text-coolGrey-1000 mx-3
          bg-coolGrey-300 outline-0 border-0 hover:bg-coolGrey-200
          transition-colors rounded-full px-5 py-2 select-none cursor-pointer`}
          onClick={() => {
            location.reload();
          }}
        >
          Try Again
        </button>
      </div>
      <div className="opacity-60 font-mono text-sm my-8">
        Error occured at location: {initialErrorLocation}
      </div>
    </div>
  );
}

export default ErrorBoundaryDisplay;
